import { Controller } from '@hotwired/stimulus'

// Live wall clock in the kiosk header. Ticks the rendered time every minute so
// a kiosk left open all shift keeps showing the current time. Locale-formatted
// to match the server-rendered seed (HH:MM, no seconds).
export class KioskClockController extends Controller {
  static targets = ['time']

  connect () {
    this.tick()
    this.timer = setInterval(() => this.tick(), 30000)
  }

  disconnect () {
    clearInterval(this.timer)
  }

  tick () {
    this.timeTarget.textContent = new Date().toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    })
  }
}
